import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { tokens } from '../tokens.js';
import { shellTokens } from './tokens.js';
/**
 * A render error anywhere in the tree otherwise unmounts everything and leaves a white
 * page with the only clue in the console. This shows the message on the page instead, so
 * a screenshot is enough to diagnose it. Function components cannot be error boundaries,
 * hence the class.
 */
export class ShellErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        console.error('VIGEO HR shell error', error, info.componentStack);
    }
    render() {
        if (this.state.error === null)
            return this.props.children;
        return (_jsxs("div", { role: "alert", style: {
                padding: tokens.spacingHorizontalXXL,
                fontFamily: tokens.fontFamilyBase,
                color: shellTokens.text1,
                backgroundColor: shellTokens.canvas,
                minHeight: '100vh',
            }, children: [_jsx("h1", { style: { fontSize: tokens.fontSizeBase500, lineHeight: tokens.lineHeightBase500, margin: 0 }, children: "Something went wrong while drawing this page" }), _jsx("p", { children: "Reload to try again. If it keeps happening, send this message to the team:" }), _jsxs("pre", { style: {
                        whiteSpace: 'pre-wrap',
                        fontFamily: tokens.fontFamilyMonospace,
                        fontSize: tokens.fontSizeBase200,
                        padding: tokens.spacingHorizontalL,
                        backgroundColor: shellTokens.surface,
                        border: `${tokens.strokeWidthThin} solid ${shellTokens.divider}`,
                        borderRadius: tokens.borderRadiusMedium,
                    }, children: [this.state.error.name, ": ", this.state.error.message, '\n', this.state.error.stack ?? ''] })] }));
    }
}
//# sourceMappingURL=ShellErrorBoundary.js.map